module.exports = __webpack_public_path__ + "static/arrow_of_slaying-1a6700d24e29624e33aa147761b4ab92.jpeg";